// mic-permission.js（或直接放同文件顶部）
import { Capacitor } from '@capacitor/core';
import { SpeechRecognition } from '@capacitor-community/speech-recognition';

export async function ensureMicPermission() {
  if (!Capacitor.isNativePlatform()) return true; // 浏览器里不需要 OS 层权限
  try {
    const { available } = await SpeechRecognition.available();
    if (!available) return true; // 设备不支持语音识别也不阻塞
    const perm = await SpeechRecognition.checkPermissions();
    if (perm?.speechRecognition === 'granted') return true;
    await SpeechRecognition.requestPermissions(); // 会请求 RECORD_AUDIO（以及 iOS 的语音识别）
    const perm2 = await SpeechRecognition.checkPermissions();
    return perm2?.speechRecognition === 'granted';
  } catch (e) {
    console.warn('ensureMicPermission error:', e);
    return false;
  }
}
